import ApiRequest from "@/shared/lib/client-sdk/api-request";
import $ from "jquery";

// Pass ignoreUserElection when the flag governs a rule the server applies to everyone, so the
// caller gets the same answer the backend enforces rather than the current user's election.
function getFeatureFlag(code, { ignoreUserElection = false } = {}) {
  const requestUrl =
    window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
    "/public/feature-flag";

  const requestData = $.param(
    ignoreUserElection
      ? { Code: code, IgnoreUserElection: true }
      : { Code: code }
  );

  const result = new Promise((resolve, reject) => {
    ApiRequest.send("GET", requestUrl, requestData).onComplete((response) => {
      if (response.successful) {
        resolve(response.result);
      } else {
        // Reject with a real Error naming the flag. The API returns an error when the flag row does
        // not exist, which happens if a bundle is deployed ahead of the migration that seeds it, so
        // the message needs to point at the flag rather than surface as an undefined rejection.
        const message = `There was an error checking the feature flag '${code}': ${
          response.message || "unknown error"
        }`;
        console.warn(message);
        reject(new Error(message));
      }
    });
  });

  return result;
}

export default getFeatureFlag;
